export default function(message) {
  throw Error(message);
}



// WEBPACK FOOTER //
// ./~/vega-util/src/error.js